import React from 'react'
import { toJS } from 'mobx'
import { observer } from 'mobx-react'
import { splitStrToChunks } from '@hlj/hlj-utils'
import { Chart, Geom, Axis, Tooltip } from 'bizcharts'

@observer
export default class extends React.Component {
  render() {
    const { dataSource, activeAnalysisTypeKey, labelTitle } = this.props.store
    const details = dataSource.details || []
    const key = activeAnalysisTypeKey.split('@')[1]
    const cols = {
      [key]: {
        alias: labelTitle,
        type: 'linear',
        formatter: val => {
          return splitStrToChunks(val, 3)
        }
      },
      daily_date: {
        alias: '日期',
        tickCount: 6
      }
    }
    return (
      <div>
        <Chart
          height={300}
          data={toJS(details)}
          scale={cols}
          padding={[20, 40, 60, 60]}
          forceFit
        >
          <Axis name="daily_date" title={true} />
          <Axis
            name={key}
            title={true}
            label={{
              autoRotate: false
            }}
            line={{
              stroke: '#dfdfdf'
            }}
          />
          <Tooltip
            crosshairs={{
              type: 'cross'
            }}
          />
          <Geom type="area" position={'daily_date*' + key} />
          <Geom type="line" position={'daily_date*' + key} size={2} />
          <Geom
            type="point"
            position={'daily_date*' + key}
            size={2}
            shape={'circle'}
            style={{
              stroke: '#fff',
              lineWidth: 1
            }}
          />
        </Chart>
      </div>
    )
  }
}
